import React, { useEffect } from 'react';
import { images } from '../../../Constants/ImageUrls';
import { getScreenName } from '../../../Utils/helper';
import { WhatsappContainer, WhatsappImage } from './styled';
import { fireEvent } from '../../../Utils/fireEvent';

export default function WhatsappStrip({ liveCountRef }) {
  const openWhatsappUrl =
    'https://wa.me/+918047190745?text=Hi, I have a question about Mylo Cloth Diaper -';
  const fireClickHandler = () => {
    fireEvent({
      category: 'clicked_card_in_myloshop',
      screen_name: getScreenName(),
      section_name: 'whatsapp strip',
      shape: 'Strip',
      page_url: window.location.href.slice(0, 99),
    });
  };
  useEffect(() => {
    fireEvent({
      category: 'served_card_in_myloshop',
      screen_name: getScreenName(),
      section_name: 'whatsapp strip',
      shape: 'Strip',
      page_url: window.location.href.slice(0, 99),
    });
  }, []);
  return (
    <WhatsappContainer ref={liveCountRef}>
      <div>
        <p className="haveMoreQues">Have more questions?</p>
        <a
          href={openWhatsappUrl}
          target="_blank"
          rel="noreferrer noopener"
          onClick={fireClickHandler}
        >
          Ask us on WhatsApp
        </a>
      </div>
      <a
        onClick={fireClickHandler}
        href={openWhatsappUrl}
        target="_blank"
        rel="noreferrer noopener"
      >
        <WhatsappImage src={images.whatsapp} alt="whatsapp" />
      </a>
    </WhatsappContainer>
  );
}
